import { BaseEditViewStore } from "core/stores";
import { InventoryCalculationCutbackService, FacilityInventoryCalculationItemService, FacilityInventoryCalculationService, FacilityOrderService } from "application/facility-order/services";
import { action, observable } from "mobx";
import { FacilityOrderTemplateEditForm } from "application/facility-order/forms";
import _ from "lodash";

class InventoryCalculationCutbackEditViewStore extends BaseEditViewStore {
	@observable accessor inventoryCalculationCutbacks = [];
	@observable accessor item = null;
	@observable accessor adjustedQtySum = 0;
	@observable accessor isDone = true;
	@observable accessor oldQuantity = [];

	constructor(rootStore) {
        const service = new InventoryCalculationCutbackService(rootStore.application.baasic.apiClient);
        const facilityInventoryCalculationItemService = new FacilityInventoryCalculationItemService(rootStore.application.baasic.apiClient);
        const facilityInventoryCalculationService = new FacilityInventoryCalculationService(rootStore.application.baasic.apiClient);
        const id = rootStore.routerStore.routerState.params.id;
        super(rootStore, {
			name: "inventory-calculation-cutback-edit",
			authorization: 'portalSection.update',
			id: id,
			Form: FacilityOrderTemplateEditForm,
			actions: {
				get: async (id) => {
					const response = await service.find({
						sort: "TemplateItem.FacilityOrderTemplate.ImportReference.IsBillableToMedicare|asc",
						calculationItemId: id,
						embed: "TemplateItem",
						rpp: 100
					});

					const responseFacilityInventoryCalculationItem = await facilityInventoryCalculationItemService.get(id, _.extend({ embed: "Product" }));
					const responseFacilityInventoryCalculation = await facilityInventoryCalculationService.get(responseFacilityInventoryCalculationItem.data.facilityInventoryCalculationId);
					this.isDone = responseFacilityInventoryCalculation.data.isDone;

					let responseData = _.extend(response.data, {
						item: _.map(response.data.item, (item => {
							return _.extend(
								item, {
								patient: item.templateItem && item.templateItem.facilityOrderTemplate && item.templateItem.facilityOrderTemplate.patient && item.templateItem.facilityOrderTemplate.patient.fullName,
								patientId: item.templateItem && item.templateItem.facilityOrderTemplate && item.templateItem.facilityOrderTemplate.patient && item.templateItem.facilityOrderTemplate.patient.id,
								patientKey: item.templateItem && item.templateItem.facilityOrderTemplate && item.templateItem.facilityOrderTemplate.patient && item.templateItem.facilityOrderTemplate.patient.patientKey,
								soQty: this.isDone? item.initialOrderQuantity : item.templateItem && item.templateItem.orderQuantity,
								adjustedQty: item.adjustedQty,
								difference: this.isDone? item.initialOrderQuantity - item.adjustedQty : item.templateItem.orderQuantity - item.adjustedQty,
								importReference: item.templateItem && item.templateItem.facilityOrderTemplate && item.templateItem.facilityOrderTemplate.importReference && item.templateItem.facilityOrderTemplate.importReference.name,
								isBillableToMedicare: item.templateItem && item.templateItem.facilityOrderTemplate && item.templateItem.facilityOrderTemplate.importReference && item.templateItem.facilityOrderTemplate.importReference.isBillableToMedicare,
								eligibilityStatus:item.templateItem && item.templateItem.facilityOrderPatient && item.templateItem.facilityOrderPatient.eligibilityStatus && item.templateItem.facilityOrderPatient.eligibilityStatus.name,
								clinicalStatus: item.templateItem && item.templateItem.facilityOrderTemplate && item.templateItem.facilityOrderTemplate.clinicalStatus && item.templateItem.facilityOrderTemplate.clinicalStatus.name,
								nonEditable: this.isNewFlow2 && item.templateItem && item.templateItem.facilityOrderTemplate && item.templateItem.facilityOrderTemplate.clinicalStatus && item.templateItem.facilityOrderTemplate.clinicalStatus.name && (item.templateItem.facilityOrderTemplate.clinicalStatus.name === "Prior Auth Obtained" || item.templateItem.facilityOrderTemplate.clinicalStatus.name === "Prior Auth Required" || item.templateItem.facilityOrderTemplate.clinicalStatus.name === "Prior Auth Pending" || item.templateItem.facilityOrderTemplate.clinicalStatus.name === "Covered" || item.templateItem.facilityOrderTemplate.clinicalStatus.name === "Does Not Meet Insurance Criteria")
							}
							);
						})),
						itemName: responseFacilityInventoryCalculationItem.data.product.itemId + " " + responseFacilityInventoryCalculationItem.data.product.description,
						quantity: responseFacilityInventoryCalculationItem.data.calculatedQuantity,
						soQuantity: responseFacilityInventoryCalculationItem.data.salesOrderQty
					});
					this.oldQuantity = response.data.item.map(x => x.adjustedQty.toString());

					if(this.isNewFlow2){
						responseData.item = _.sortBy(responseData.item, i => (i.nonEditable ? true : false))
					}
					return responseData;
				},
				batchUpdateItems: async () => {
					const inventoryCalculationCutbacks = this.inventoryCalculationCutbacks;
					if (inventoryCalculationCutbacks.length > 0) {
						try {
							var adjustedQtyArray = [];
							_.forEach(inventoryCalculationCutbacks, function (item) {
								adjustedQtyArray.push(parseInt(item.adjustedQty));
							})
							var sum = _.sum(adjustedQtyArray);
							if (this.soQuantity < sum) {
								rootStore.notificationStore.error("Total Cutback Quantity can't be higher than the Total Sales Order Quantity.");
								return null;
							}

							if (this.quantity < sum) {
								this.rootStore.modalStore.showConfirm(
									"You are cutting back on more than what the system calculated. Are you sure you want to proceed?",
									async () => {
										const response = await service.batchUpdate(inventoryCalculationCutbacks);
										rootStore.notificationStore.success('LIST_LAYOUT.SUCCESS_BATCH_UPDATE');
										return response.data;
									}
								);
							}
							else {
								const response = await service.batchUpdate(inventoryCalculationCutbacks);
								rootStore.notificationStore.success('LIST_LAYOUT.SUCCESS_BATCH_UPDATE');
								return response.data;
							}
						}
						catch (err) {
							rootStore.notificationStore.error('LIST_LAYOUT.ERROR_BATCH_UPDATE');
						}
					}
					return null;
				}
			},
			FormClass: FacilityOrderTemplateEditForm,
		});

        this.facilityOrderId = this.rootStore.routerStore.routerState.params.facilityOrderId;
        this.service = new InventoryCalculationCutbackService(rootStore.application.baasic.apiClient);
        this.facilityOrderService = new FacilityOrderService(this.rootStore.application.baasic.apiClient);
        this.id = this.rootStore.routerStore.routerState.params.id;
        this.isCutback = `${this.rootStore.routerStore.routerState.params.isCutback}` == 'true';
        this.isNewFlow2 = this.rootStore.routerStore.routerState.routeName.includes("new-flow");
    }

	@action
	async setItem(item) {
		this.item = item.itemName;
		this.quantity = item.quantity;
		this.soQuantity = item.soQuantity;
		this.itemInitialized = true;
		this.inventoryCalculationCutbacks = item.item;
		this.templateItemsRowRefs = [];
		var adjustedQtyArray = [];
		_.forEach(this.inventoryCalculationCutbacks, function (i) {
			adjustedQtyArray.push(i.adjustedQty);
		})
		this.adjustedQtySum = _.sum(adjustedQtyArray);
		this.facilityOrder = (await this.facilityOrderService.get(this.facilityOrderId, { fields: "isNewFlow2" })).data;
	}

	@action.bound
	showPatientTemplates(patientId, patientKey) {
		if(!this.facilityOrder.isNewFlow2){
			let url = this.rootStore.routerStore.findRoute('master.app.main.facility-order.facility-order-template.edit').pattern;
			url = url.replace(":facilityOrderId", this.rootStore.routerStore.routerState.params.facilityOrderId).replace(":patientId", patientId).replace(":patientKey", patientKey);
			window.open(`${url}`);
		}
	}

	@action.bound
	onAdjustedQuantityFieldBlur(index, value) {
		if (value == null || value == undefined || value === "")
			value = 0;
		if (parseInt(value) == parseInt(this.oldQuantity[index]) || parseInt(value) < 0) {
			return;
		}
		this.oldQuantity[index] = parseInt(value);
	}

	@action.bound
	editItem(index, value, propertyName) {
		if (value <= this.inventoryCalculationCutbacks[index]['soQty']) {
			this.inventoryCalculationCutbacks[index][propertyName] = value;
			this.inventoryCalculationCutbacks[index]['difference'] = this.inventoryCalculationCutbacks[index]['soQty'] - value;
		}
		var adjustedQtyArray = [];
		_.forEach(this.inventoryCalculationCutbacks, function (i) {
			adjustedQtyArray.push(parseInt(i.adjustedQty));
		})
		this.adjustedQtySum = _.sum(adjustedQtyArray);
	}

	@action.bound
	async updateItems() {
		try {
			var response = await this.actions.batchUpdateItems();
			if (response != null) {
				this.rootStore.routerStore.goTo(
					'master.app.main.facility-order.facility-inventory-calculation-items.list',
					{ facilityOrderId: this.facilityOrderId }
				);
			}
		}
		catch (err) {
			this.rootStore.notificationStore.error('LIST_LAYOUT.ERROR_BATCH_UPDATE');
		}
	}

	@action.bound
	editCutbackQuantity(value) {
		this.adjustedQtySum = value;
	}

	@action.bound
	async updateCutbackAdjustedQty() {
		try {
			if(this.isNewFlow2){
				await this.service.updateCutbackAdjustedQtyNewFlow({ calculationItemId: this.id, adjustedQty: this.adjustedQtySum });
			}
			else{
				await this.service.updateCutbackAdjustedQty({ calculationItemId: this.id, adjustedQty: this.adjustedQtySum });
			}
			this.rootStore.notificationStore.success("Total Cutback Quantity successfully updated.");
		} catch (err) {
			this.rootStore.notificationStore.error( err && err.data && err.data.errors ? err.data.errors : "Error occurred while trying to change Total Cutback Quantity.");
		}
		
		await this.initialize();
	}
}

export default InventoryCalculationCutbackEditViewStore;